// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CircleDot as RawCircleDot } from "lucide-react";
export const CircleDot = /* @__PURE__ */ createIcon(RawCircleDot, "CircleDot", 2);
